import { render, staticRenderFns } from "./index2025.vue?vue&type=template&id=347d1b4e&scoped=true"
import script from "./index2025.vue?vue&type=script&lang=js"
export * from "./index2025.vue?vue&type=script&lang=js"
import style0 from "./index2025.vue?vue&type=style&index=0&id=347d1b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d1b4e",
  null
  
)

export default component.exports